import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleActivityConfiguration = {
  namespaced: true,

  state: {
    name: 'activity-configuration',
    activityConfigurations: []
  },

  mutations,
  getters,
  actions
}

export default moduleActivityConfiguration;